import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/Explorer/Model.ts";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { createStore, createEvent } from 'effector';
import { useStore, useStoreMap } from 'effector-react';
import { assertNever } from '@gmini/utils';
export function useHover() {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      hover = _React$useState2[0],
      setHover = _React$useState2[1];

  var onMouseOver = React.useCallback(function () {
    return setHover(true);
  }, []);
  var onMouseLeave = React.useCallback(function () {
    return setHover(false);
  }, []);
  return React.useMemo(function () {
    return {
      hover: hover,
      onMouseOver: onMouseOver,
      onMouseLeave: onMouseLeave
    };
  }, [hover, onMouseLeave, onMouseOver]);
}
export var openNewItemForm = createEvent('openNewCategoryForm', {
  name: "openNewItemForm",
  sid: "9bn6de"
});
export var openNewCategoryForm = createEvent('openNewCategoryForm', {
  name: "openNewCategoryForm",
  sid: "-lqkhdd"
});
export var openNewEntityForm = createEvent('openNewEntityForm', {
  name: "openNewEntityForm",
  sid: "734y7m"
});
export var openNewAssemblyForm = createEvent('openNewAssemblyForm', {
  name: "openNewAssemblyForm",
  sid: "-9bt5ox"
});
export var openCopyForm = createEvent('openCopyForm', {
  name: "openCopyForm",
  sid: "-bav05n"
});
export var openRenameItemForm = createEvent('openRenameItemForm', {
  name: "openRenameItemForm",
  sid: "8do1an"
});
export var closeItemForm = createEvent('closeNewItemForm', {
  name: "closeItemForm",
  sid: "-15u5by"
});
export var itemFormRef$ = createStore(null, {
  name: "itemFormRef$",
  sid: "y35ge3"
}).on(openNewItemForm, function (_, _ref) {
  var type = _ref.type,
      parentCategoryId = _ref.parentCategoryId;
  return {
    type: 'Creating',
    itemType: type,
    parentCategoryId: parentCategoryId
  };
}).on(openNewCategoryForm, function (_, _ref2) {
  var parentCategoryId = _ref2.parentCategoryId;
  return {
    type: 'Creating',
    itemType: 'Category',
    parentCategoryId: parentCategoryId
  };
}).on(openNewEntityForm, function (_, _ref3) {
  var parentCategoryId = _ref3.parentCategoryId;
  return {
    type: 'Creating',
    itemType: 'Entity',
    parentCategoryId: parentCategoryId
  };
}).on(openNewAssemblyForm, function (_, _ref4) {
  var parentCategoryId = _ref4.parentCategoryId;
  return {
    type: 'Creating',
    itemType: 'Assembly',
    parentCategoryId: parentCategoryId
  };
}).on(openCopyForm, function (_, _ref5) {
  var id = _ref5.id,
      parentCategoryId = _ref5.parentCategoryId,
      version = _ref5.version,
      type = _ref5.type;
  return {
    type: 'Copying',
    itemId: id,
    itemType: type,
    parentCategoryId: parentCategoryId,
    version: version
  };
}).on(openRenameItemForm, function (_, itemRef) {
  return {
    type: 'Renaming',
    itemId: itemRef.id,
    itemType: itemRef.type,
    version: itemRef.version
  };
}).reset(closeItemForm);
export var creationUpdate = itemFormRef$.updates.filterMap(function (update) {
  return (update === null || update === void 0 ? void 0 : update.type) === 'Creating';
});
export var useItemFormRef = function useItemFormRef() {
  return useStore(itemFormRef$);
};

var createHook = function createHook(type) {
  return function () {
    return useStoreMap({
      store: itemFormRef$,
      keys: [type],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      fn: function fn(itemFormRef, _ref6) {
        var _ref7 = _slicedToArray(_ref6, 1),
            type = _ref7[0];

        return (itemFormRef === null || itemFormRef === void 0 ? void 0 : itemFormRef.type) === type ? itemFormRef : null;
      }
    });
  };
};

export var useNewItemFormRef = createHook('Creating');
export var useCopyEntityFormRef = createHook('Copying');
export function useCurrentRenaming(nodeRef) {
  return useStoreMap({
    store: itemFormRef$,
    keys: [nodeRef.type, nodeRef.id],
    fn: function fn(itemFormRef, _ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
          type = _ref9[0],
          id = _ref9[1];

      return !!itemFormRef && itemFormRef.type === 'Renaming' && itemFormRef.itemId === id && itemFormRef.itemType === type;
    }
  });
}
export function useCurrentCopying(nodeRef) {
  return useStoreMap({
    store: itemFormRef$,
    keys: [nodeRef.id],
    fn: function fn(itemFormRef, _ref10) {
      var _ref11 = _slicedToArray(_ref10, 1),
          id = _ref11[0];

      return !!itemFormRef && itemFormRef.type === 'Copying' && itemFormRef.itemId === id;
    }
  });
}
export function fromEntityTreeData(_ref12) {
  var source = _ref12.source,
      parentNode = _ref12.parentNode;
  return source ? source.map(function (s) {
    var node = parentNode.type === 'Root' ? null : parentNode;

    var treeNode = _objectSpread(_objectSpread({}, s), {}, {
      parentNode: node
    });

    return {
      key: buildItemKey({
        node: s
      }),
      payload: treeNode,
      skeletonTotal: 'total' in s ? s.total : 0,
      children: 'children' in s ? fromEntityTreeData({
        source: s.children,
        parentNode: s
      }) : []
    };
  }) : [];
}
export function generateName(name, existingNames) {
  var newName = "\u041A\u043E\u043F\u0438\u044F ".concat(name);
  return existingNames.includes(newName) ? generateName(newName, existingNames) : newName;
}
export function findEntityOrAssembly(_ref13) {
  var itemId = _ref13.itemId,
      itemType = _ref13.itemType,
      tree = _ref13.tree;
  var node = find({
    root: tree,
    id: itemId,
    type: itemType
  });
  return (node === null || node === void 0 ? void 0 : node.type) === 'Entity' || (node === null || node === void 0 ? void 0 : node.type) === 'Assembly' ? node : null;
}
export function findParent(_ref14) {
  var parentCategoryId = _ref14.parentCategoryId,
      tree = _ref14.tree;
  var node = find({
    root: tree,
    id: parentCategoryId,
    type: 'Category'
  });
  return (node === null || node === void 0 ? void 0 : node.type) !== 'Entity' && (node === null || node === void 0 ? void 0 : node.type) !== 'Assembly' ? node : null;
}
export function find(_ref15) {
  var root = _ref15.root,
      id = _ref15.id,
      type = _ref15.type;
  var node = null;

  if (!id) {
    return root.reduce(function (acc, next) {
      return next ? _objectSpread(_objectSpread({}, acc), next) : acc;
    }, {});
  }

  function recursive(items) {
    items.forEach(function (item) {
      if (item.type === type && item.id === id) {
        node = item;
      } else if ('children' in item) {
        recursive(item.children);
      }
    });
  }

  recursive(root.flatMap(function (_root) {
    return _root.children;
  }));
  return node;
}
export function setNewItem(_ref16) {
  var root = _ref16.root,
      newNode = _ref16.newNode;

  if (!root.some(function (root) {
    return root.children.length;
  })) {
    return root.map(function (rootNode) {
      return _objectSpread(_objectSpread({}, rootNode), {}, {
        children: [newNode]
      });
    });
  }

  return addNodeUnderParent({
    root: root,
    newNode: newNode,
    parentKey: buildParentKey(newNode)
  });
}
export function addNodeUnderParent(_ref17) {
  var root = _ref17.root,
      newNode = _ref17.newNode,
      parentKey = _ref17.parentKey;
  return root.map(function (_root) {
    if (buildItemKey({
      node: _root
    }) === parentKey) {
      return _objectSpread(_objectSpread({}, _root), {}, {
        children: [newNode].concat(_toConsumableArray(_root.children))
      });
    }

    var recursive = function recursive(items) {
      return items.map(function (item) {
        if (buildItemKey({
          node: item
        }) === parentKey) {
          return _objectSpread(_objectSpread({}, item), {}, {
            children: 'children' in item ? [newNode].concat(_toConsumableArray(item.children)) : [newNode]
          });
        }

        if ('children' in item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            children: recursive(item.children)
          });
        }

        return item;
      });
    };

    return _objectSpread(_objectSpread({}, _root), {}, {
      children: recursive(_root.children)
    });
  });
}
export function buildItemKey(_ref18) {
  var node = _ref18.node;

  switch (node.type) {
    case 'Category':
    case 'Assembly':
    case 'Entity':
      return "".concat(node.type, ":").concat(node.id);

    case 'NewCopy':
      return "".concat(node.type, ":").concat(node.parentCategoryId);

    case 'NewItem':
      return "".concat(node.type, ":").concat(node.parentCategoryId);

    case 'Root':
      return "".concat(node.type, ":").concat(node.id);

    default:
      return assertNever('Unexpected node', node);
  }
}
export function buildParentKey(node) {
  return node.parentCategoryId ? "Category:".concat(node.parentCategoryId) : 'Root:root';
}
export function parentContainsChild(_ref19) {
  var parent = _ref19.parent,
      child = _ref19.child;

  if (parent.id === child.id && parent.type !== 'Entity') {
    return true;
  }

  if ('children' in parent) {
    return parent.children.some(function (parentChild) {
      return 'children' in parentChild ? parentContainsChild({
        parent: parentChild,
        child: child
      }) : !!(parentChild.id === child.id && parentChild.type !== 'Entity');
    });
  }

  return false;
}